'use client';

import * as React from 'react';
import classNames from 'classnames';
import Icon from '@/components/ui/Icon';
import LoadingContent from '../LoadingContent';
import './styles.scss';

export interface IControlDateProps extends React.HTMLProps<HTMLInputElement> {
  /** Color higlight for errors */
  hasError?: boolean;
  /** Pass input ref */
  inputRef?: React.RefCallback<HTMLInputElement>;
  /** Loading */
  loading?: boolean;
}

/**
 * Regular HTML input field with extended functionality and styling. Use this within form row.
 */
const ControlDate: React.FunctionComponent<IControlDateProps> = (props) => {
  const { inputRef, hasError, onFocus, onBlur, className, ...rest } = props;
  const [hasFocus, setHasFocus] = React.useState(false);
  const localInputRef = React.useRef<HTMLInputElement | null>(null);

  return (
    <div
      className={classNames(
        'control-date',
        {
          ['has-error']: hasError,
          ['focus']: hasFocus,
          ['disabled']: props.disabled,
        },
        className,
      )}
      style={props.style}
    >
      <div className={'control-date__holder'}>
        <input
          {...rest}
          type="date"
          className={'control-date__input'}
          onFocus={(e) => {
            setHasFocus(true);
            if (onFocus) {
              onFocus(e);
            }
          }}
          onBlur={(e) => {
            setHasFocus(false);
            if (onBlur) {
              onBlur(e);
            }
          }}
          ref={(e) => {
            if (inputRef) {
              inputRef(e);
            }
            if (e) {
              localInputRef.current = e;
              if (props.autoFocus) {
                window.requestAnimationFrame(() => {
                  e.focus();
                });
              }
            }
          }}
          aria-busy={props.loading}
        />
        <div className={'control-date__icon'}>
          <Icon
            width={24}
            height={24}
            kind="calendar-month"
          />
        </div>
      </div>
      {props.loading && (
        <span className={'control-date__loader'}>
          <LoadingContent size="tiny" />
        </span>
      )}
    </div>
  );
};

ControlDate.displayName = 'ControlDate';

export default ControlDate;
